<template>
    <div class="details">
        <titleBar :title="title"></titleBar>
        <div class="details_content">
            <div class="details_bgimg" v-if="data.imgList" @click="closeModal">
                <img v-for="(item , index) in data.imgList" :key="index" :src="item">
            </div>
            <div class="details_bottom">
                <template v-if="btn_status">
                    <div class="details_bottom_left"  @click="modal_event">
                        <div class="details_money">
                            <span class="details_money_nofree"><div class="logo">¥</div>{{transMoney(current.price)}}</span>
                        </div>
                        <div class="details_info">
                            <div class="time">
                                <span>{{current.liveTime}}</span>
                                <span  v-if="data.courseList.length>1" class="arrow"  :class="{up: mark_show}"></span>
                            </div>
                            <div class="origin_price">
                                ¥{{transMoney(current.originPrice)}}
                            </div>
                        </div>
                    </div>
                    <div class="details_bottom_right">
                        <span v-if="current.orderId" @click="go_pay">去支付</span>
                        <template v-else>
                            <span v-if="data.isBuy == 0" @click="pay_click">立即提升</span>
                            <span v-if="data.isBuy == 1  && price != 0 " @click.stop>已购买</span>
                            <span v-if="data.isBuy == 1  && price == 0 " @click.stop>已报名</span>
                        </template>
                    </div>
                </template>
            </div>
            <div v-if="mark_show" class="mark" @click="modal_event">
                <div class="mark_item" ref="modal" @click.stop>
                    <h3>可选课程</h3>
                    <p v-for="(k,i) in data.courseList" :key="i" @click="select_class(i)" :class="{cur : selectIndex == i}">{{k.liveTime}}</p>
                </div>
            </div>
        </div>
        <div v-if="tips" class="mark" @click="close_tips" @touchmove.prevent>
            <div class="tips_bottom" @click.stop>
                <div v-if="tips == 'method'" class="method">
                    <h2>上课方式</h2>
                    <p>1.电脑：浏览器打开官网<span @click="copy_event">复制网址</span></p>
                    <p>2.手机/pad：应用市场内下载小象辅导APP</p>
                    <p>3.如有疑问可咨询人工客服<span><a @click="call_event">拨打电话</a></span></p>
                    <p>记得使用家长盒子的注册手机号登录哦～</p>
                </div>
            </div>
        </div>
        <p v-if="toast" class="toast">{{toast}}</p>
        <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
    </div>
</template>

<script>
  import ajax from '@/api/lightAjax.js'
  import utils from '@/assets/js/utils'
  import titleBar from '@/components/common/titleBar.vue'
  import lesson_loading from '@/components/common/lesson_loading.vue'
  import BSroll from  'better-scroll'
  let vm = null
  window.callback = function (obj) {
    vm.creatOrder(JSON.parse(obj))
  }
  window.onVisible = function (){
    vm.initData()
  }
  window.verifyParentCallback = function(){
    window.location = 'hybird://method/nativeToJS?funcName=callback'
  }
  let publicPath = {
    test: 'https://qa.knowbox.cn:8018',
    preview: 'https://preshark.knowbox.cn:8042',
    production: 'https://stuapi.knowbox.cn',
  };
  export default {
    name: '',
    data() {
      return {
        title: '活动详情',
        index: 0,
        people: 130,
        data: {
          imgList:[],
          courseList:[]
        },
        selectIndex : 0,
        time: '',
        price: '',
        mark_show: false,
        productList: [],
        btn_status: true,
        loadingLock: true,
        status: 'loading',
        token: '',
        isShow: false,
        tips: '',
        toast: '',
        current: {}
      }
    },
    components: {
      titleBar,
      lesson_loading
    },
    watch:{
      toast(newName, oldName) {
        let self = this
        if(newName != ''){
          setTimeout(function () {
            self.toast = ''
          },2000)
        }
      }
    },
    methods: {
      transMoney: function(cashNum){
        return (parseInt(cashNum)/100).toFixed(2)
      },
      modal_event() {
        let self = this
        console.log(self.data.courseList)
        if(self.data.courseList.length <= 1) return
        self.mark_show = !self.mark_show
        utils.sendLog({
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            event: 2,
          }
        }, 'hzxx625')
      },
      close_tips(){
        this.tips = ''
      },
      closeModal() {
        this.btn_status = true
        this.isShow = false
        this.$refs.modal.style.transform = "translateY(6.06rem)"
        this.$refs.modal.style.transition = "transform .6s ease-in-out"
      },
      select_class(i) {
        this.selectIndex = i
        this.time = this.data.courseList[this.selectIndex].liveTime
        this.current = this.data.courseList[this.selectIndex]
      },
      initData: async function() {
        let self = this
        const api = self.isReport ? '/light/live-introduce/sale-page-from-xue-qing' : '/light/live-introduce/sale-page-from-ad'
        const [resp] = await ajax.all([
          ajax.get(api, {
            params: {
              token: self.token,
              courseId: self.courseId,
            }
          })
        ])
        if(resp.data.code == 99999){
          this.data = resp.data.data
          self.time = self.data.courseList[self.selectIndex].liveTime
          for(let i = 0; i < self.data.courseList.length; i++){
            if(self.data.courseList[i].selected){
              self.index = i
              self.current = self.data.courseList[i]
            }
          }
          this.loadingLock = false
          if(self.data.courseList.length){
            this.loadingLock = false
          }else{
            this.status = 'empty'
          }
          this.$nextTick(function(){
            if(self.$refs.list_item){
              self.scroll = new BSroll(self.$refs.list_item,{
                click: true
              })
            }
          })
        }else{
          this.loadingLock = true
          this.status = 'error'
        }
      },
      creatOrder : async function(obj) {
        let self = this
        const [resp] = await ajax.all([
          ajax.post('/light/live-order/order-add', {
            token: self.token,
            source: obj.source,
            version: obj.version,
            productId: self.current.productId,
            identity: 'parent',
            userSource: 'LIVENETSCHOOL',
            clientChannel: obj.channel,
            clientVersion: obj.appVersion,
            deviceBrand: obj.platform,
            deviceModel: obj.platform,
            OSName: obj.platform,
            OSVersion: obj.deviceVersion,
            pageChannel: utils.getQueryString('pageChannel'),
            channel: 'i_xhjz',
          })
        ])
        if(resp.data.code == 99999){
          this.current.orderId = resp.data.data.orderId
          if(parseInt(this.current.price) == 0){
            if(this.current.goToPage){
              return this.$router.push({path: '/lightLesson/free_pay_sucess?isGoToPage=' + self.current.goToPage + '&token=' + self.token + '&classNumber=' + self.current.classNumber + '&courseId=' + self.courseId})
            }else {
              return this.$router.push({path: '/lightLesson/pay_sucess?version=' + self.version + '&token=' + self.token + '&source=' + self.source + '&courseID=' + self.courseId})
            }
          }
          let url;
          if(parseInt(self.current.goToPage)){
            url = window.location.origin + '/#/lightLesson/free_pay_sucess?hideTitleBar=1&courseId=' + self.courseId + '&token=' + self.token + '&source=' + self.source + '&version=' + self.version
          }else{
            url = window.location.origin + '/#/lightLesson/pay_sucess?hideTitleBar=1&version=' + self.version + '&token=' + self.token + '&source=' + self.source + '&courseID=' + self.courseId
          }
          window.location = 'hybird://method/buyLiveCourse?orderId=' + self.current.orderId + '&payHost=' + escape(publicPath[process.env.VUE_APP_INTER]) + '&orderInfoPath=/light/live-order/order-info&successUrl=' + escape(url) + '&showAddress=0&chargePath=light/live-order/order-add-pay-obj&verifyPath=light/live-order/order-verify'
        }else{
          this.btn_status = true
        }
      },
      payYICourse:function(){
        let self = this
        utils.sendLog({
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            adId: self.activityId,
            event: 3,
            courseID: self.courseId,
          }
        }, 'hzxx454')
        window.location = 'hybird://method/nativeToJS?funcName=callback'
      },
      goYIPay () {
        let url = window.location.origin + '/#/lightLesson/free_pay_sucess?hideTitleBar=1&courseId=' + this.courseId + '&token=' + this.token + '&source=' + this.source + '&version=' + this.version
        window.location = 'hybird://method/buyLiveCourse?orderId=' + this.current.orderId + '&payHost=' + escape(publicPath[process.env.VUE_APP_INTER]) + '&orderInfoPath=/light/live-order/order-info&successUrl=' + escape(url) + '&showAddress=0&chargePath=light/live-order/order-add-pay-obj&verifyPath=light/live-order/order-verify'
      },
      payZeroCourse () {
        let self = this
        let version = Number(this.version)
        utils.sendLog({
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            courseID: self.courseId,
          }
        }, 'hzxx626')
        if(!this.data.isBuy){
          if(version >= 4072){
            window.location = 'hybird://method/verifyParent'
          }else{
            window.location = 'hybird://method/nativeToJS?funcName=callback'
          }
        }else{
          self.go_sucess()
        }
      },
      pay_click:function () {
        let self = this
        if(!self.current.productId){
          self.toast = '请选择购买的课程'
          return
        }
        if(parseInt(self.current.price)!=0){
          // 1元课售卖
          self.payYICourse()
        } else {
          // 0元课售卖
          self.payZeroCourse()
        }
      },
      go_pay: function(){
        let self = this
        self.goYIPay()
      },
      copy_event : function() {
        window.location = 'hybird://method/copy2Clipboard?content=vip.knowbox.cn'
      },
      call_event (){
        window.location = 'hybird://method/openBrowser?url=' + decodeURI('tel://400-010-0180')
      },
      show_method (){
        this.tips = 'method'
      },
      // tranferTime: function(timestamp){
      //   var time = new Date(timestamp * 1000)
      //   return (time.getMonth()+1)+'月'+ time.getDay()+'日'
      // }
    },
    created: function () {
      let self = this
      vm = this
      self.token = utils.getQueryString('token')
      self.courseId = utils.getQueryString('courseId')
      self.isReport = utils.getQueryString('isReport')
      self.source = utils.getQueryString('source')
      self.version = utils.getQueryString('version').substr(0,4)
      self.activityId = utils.getQueryString('activityId')
      utils.sendLog({
        token: self.token,
        version: self.version,
        source: self.source,
        extensionJson: {
          adId: self.activityId,
          courseID: self.courseId,
        }
      }, 'hzxx806')
      self.initData()
    }
  }
</script>

<style lang="scss">
    @font-face{
        font-family: "BebasNeueBold";
        src: url('https://appd.knowbox.cn/ss/v310/BebasNeueBold.ttf');
    }
    .details_bottom {
        position: fixed;
        z-index: 100;
        bottom: 0;
        width: 100%;
        height: 1.1rem;
        background-color: #f5833d;
        z-index: 101;
        border-top: 1px solid #f0eff1;
        p{
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: .38rem;
            line-height: 1.1rem;
            color: #ffffff;
        }
    }
    .details_bottom_left {
        float: left;
        height: 1.1rem;
        width: 70%;
        text-align: center;
        line-height: 0.88rem;
        background-color: #fff;
        display: flex;
    }
    .details_money {
        box-sizing: border-box;
        padding-left: 0.5rem;
        display: flex;
        align-items: center;
    }
    .details_info{
        flex: 1;
        flex-direction: column;
        text-align: left;
        padding: 0.24rem 0 0.24rem 0.2rem;
        .time{
            font-family: "PingFangSC-Semibold";
            font-size: .26rem;
            color: #919294;
            line-height: .26rem;
            .arrow{
                width: 0.18rem;
                height: 0.14rem;
                display: inline-block;
                background: url("../../assets/images/light_lesson/arrow_down.png") 0 0 /cover no-repeat;
                margin-bottom: 0.04rem;
                margin-left: 0.1rem;
                transition: all 300ms linear;
            }
            .arrow.up{
                transform: rotate(-180deg);
            }
        }

        .origin_price{
            font-family: "BebasNeueBold";
            font-size: 0.22rem;
            line-height: .22rem;
            color: #bec0c2;
            margin-top: .12rem;
            text-decoration: line-through;
        }
    }
    .details_money_free {
        color: #ff714c;
        font-size: 0.36rem;
    }
    .details_money_nofree {
        color: rgb(253,96,96);
        font-size: 0.72rem;
        height: 0.72rem;
        font-family: "BebasNeueBold";
        position: relative;
        padding-left: 0.3rem;
        div.logo{
            position: absolute;
            left: 0;
            top: 0.02rem;
            font-size: 0.4rem;
            width: 0.4rem;
            height: 0.72rem;
            overflow: hidden;
            text-align: center;
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            justify-content: flex-end;
        }
    }
    .details_money_nofree span {
        color: #ff714c;
        font-size: 0.24rem;
        font-weight: 100;
        font-family: PingFangSC-Medium;
    }
    .details_people {
        font-size: 0.24rem;
        padding-right: 0.7rem;
        line-height: .25rem;
        padding-top: .48rem;
        float: right;
        color: #9796a4;
        font-family: PingFangSC-Medium;
    }
    .details_bottom_right {
        text-align: center;
        width: 30%;
        float: right;
        line-height: 1.1rem;
        color: #ffffff;
        background-color: rgb(253,96,96);
        font-size: 0.36rem;
        font-family: PingFangSC-Medium;
        text-shadow: 0 0.04rem 0.04em #ff3b3b;
    }
    .details_bottom_tips{
        position: fixed;
        bottom: 1.1rem;
        width: 100%;
        height: .6rem;
        font-family: PingFangSC-Medium;
        font-size: .26rem;
        line-height: .6rem;
        color: #ffffff;
        background-color: #000000;
        opacity: 0.7;
        text-align: center;
        z-index: 999;
    }
    .details_shadow {
        position: fixed;
        z-index: 99;
        opacity: 0.3;
        width: 100%;
        height: 100%;
        background-color: #000;
    }
    .details_bgimg{
        margin-top: .88rem;
        margin-bottom: 1.1rem;
        img{
            width: 100%;
        }
    }
    .details_modal {
        position: fixed;
        bottom: -6.06rem;
        z-index: 100;
        width: 100%;
        height: 6.06rem;
        border-top-left-radius:12px;
        border-top-right-radius: 12px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0.42rem 0.5rem 0;
        &_title {
            color: #56586a;
            &_top {
                font-family: PingFangSC-Medium;
                font-weight: 900;
                font-size: 0.32rem;
                color: #919294;
                display: block;
                width: 1.8rem;
                margin: 0 auto;
                text-align: center;
                position: relative;
            }
            &_top::before{
                content: '';
                display: table;
                width: 4px;
                height: 2px;
                border-radius: 0.01rem;
                background-color: #e2e2e2;
                position: absolute;
                top: 12px;
                left: 0;
            }
            &_top::after{
                content: '';
                display: table;
                width: 4px;
                height: 2px;
                border-radius: 1px;
                background-color: #e2e2e2;
                position: absolute;
                top: 10px;
                right: 0;
            }
            &_middle {
                margin-bottom: .18rem;
                font-family: PingFangSC-Regular;
                font-size: 0.26rem;
                span {
                    padding-right: 0.3rem;
                }
            }
        }
        &_item{
            padding-top: 0.5rem;
            padding-bottom: .2rem;
            height: 4.5rem;
            overflow-y: scroll;
            &_main {
                position: relative;
                padding-left: 0.52rem;
                margin-bottom: 0.3rem;
                box-sizing: border-box;
                width: 100%;
                height: .98rem;
                background: #fafafa;
                font-size: 0.20rem;
                position: relative;
                border-radius: .5rem;
                display: flex;
                .itemWrap{
                    display: flex;
                    flex: 1;
                    align-items: center;
                }
                .time{
                    flex: 1;
                    font-size: 14px;
                    color: #4a4b4c;
                    font-family: PingFangSC-Medium;
                }
                .info {
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                    span{
                        font-family: PingFangSC-Medium;
                        font-size: .28rem;
                        color: #919294;
                        padding-right: 0.28rem;
                        align-items: center;
                        display: flex;
                    }
                    img{
                        width: .78rem;
                        height: .78rem;
                        border: 1px solid #e4ebf0;
                        border-radius: 50%;
                    }
                }

                /*&:after {*/
                /*content: "";*/
                /*position: absolute;*/
                /*bottom: 0;*/
                /*left: 0;*/
                /*width: 100%;*/
                /*height: 1px;*/
                /*background: #eeeeee;*/
                /*transform: scaleY(0.5);*/
                /*}*/
                &_header {
                    float: left;
                    margin: 0.1rem 0.2rem 0.1rem 0.1rem;
                    width: 0.6rem;
                    height: 0.6rem;
                    background: pink;
                    border-radius: 50%;
                }
                &_detail {
                    position: relative;
                    height: 100%;
                    &_time {
                        font-family: PingFangSC-Regular;
                        font-size: .26rem;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        padding-bottom: 0.2rem;
                        color: #9796a4;
                    }
                    &_other {
                        font-family: PingFangSC-Regular;
                        font-size: .24rem;
                        color: #56546c;
                        height: .2rem;
                        line-height: .2rem;
                        span {
                            font-family: PingFangSC-Medium;
                            margin-right: 0.2rem;
                        }
                        &_1 {
                            font-size: .2rem;
                            margin-right: 0.2rem;
                            font-weight: normal;
                            background-color: #eaebf1;
                            padding: 0 0.1rem;
                            border-radius: 0.2rem;
                            color: #9ea2b7;
                            -webkit-text-size-adjust: none;
                        }
                        &_2 {
                            font-size: .2rem;
                            margin-right: 0.2rem;
                            font-weight: normal;
                            background-color: #eaebf1;
                            padding: 0 0.1rem;
                            border-radius: 0.2rem;
                            color: #b48051;
                            -webkit-text-size-adjust: none;
                        }
                    }

                }
                &_radio {
                    display: block;
                    position: absolute;
                    right: .57rem;
                    bottom: .2rem;
                    height: .36rem;
                    font-family: PingFangSC-Medium;
                    font-size: .32rem;
                    color: #ff714c;
                    line-height: .36rem;
                }
                input[type="checkbox"] {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                    opacity: 0;
                    top: 0;
                }
                input:checked+label {
                    // background-color: #fe6d32;
                    border: 1px solid #9ea2b7;
                }
                input:checked+label::after {
                    position: absolute;
                    content: "";
                    width: 0.16rem;
                    height: 0.16rem;
                    top: 0.08rem;
                    left: 0.08rem;
                    background-color: #9ea2b7;
                    border-radius: 100%;
                }
                label {
                    position: absolute;
                    right: 0;
                    bottom: .2rem;
                    width: 0.36rem;
                    height: 0.36rem;
                    border-radius: 50%;
                    border: 1px solid #999;
                }
                input:checked+label::after {
                    position: absolute;
                    content: "";
                    width: 0.16rem;
                    height: 0.16rem;
                    top: 0.08rem;
                    left: 0.08rem;
                    background-color: #9ea2b7;
                    border-radius: 100%;
                }
                .no_check{
                    opacity: .5;
                }
            }
            &_main.activity{
                background: #ffecec;
            }
        }
    }
    .mark{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
        background-color: rgba(0,0,0,.7);
        .mark_item{
            position: fixed;
            bottom: 1rem;
            z-index: 100;
            width: 100%;
            // height: 4.75rem;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            background-color: #fff;
            box-sizing: border-box;
            padding: 0.5rem 0.4rem .5rem;
            h3{
                margin-bottom: .5rem;
                height: .25rem;
                line-height: .25rem;
                font-family: PingFangSC-Regular;
                font-size: .26rem;
                color: #919294;
                text-align: center;
                &:before{
                    display: inline-block;
                    content: '';
                    margin-bottom: .08rem;
                    margin-right: .2rem;
                    width: 10px;
                    height: 1px;
                    background-color: #919294;
                    border-radius: 1px;
                }
                &:after{
                    display: inline-block;
                    content: '';
                    margin-bottom: .08rem;
                    margin-left: .2rem;
                    width: 10px;
                    height: 1px;
                    background-color: #919294;
                    border-radius: 1px;
                }
            }
            p{
                margin-bottom: .3rem;
                width: 3.2rem;
                height: .8rem;
                line-height: .8rem;
                background-color: #fafafa;
                border-radius: .4rem;
                /*border: solid 2px #ff7575;*/
                box-sizing: border-box;
                font-family: PingFangSC-Medium;
                font-size: .26rem;
                color: #424243;
                text-align: center;
                &:nth-child(odd){
                    float: right;
                }
                &:nth-child(even){
                    float: left;
                }
            }
            .cur{
                color: #ff7575;
                border: solid 1px #ff7575;
            }
        }
    }
    .toast{
        position: fixed;
        width: 3rem;
        height: 1.5rem;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        font-family: PingFangSC-Medium;
        font-size: .3rem;
        line-height: 1.5rem;
        text-align: center;
        color: #fff;
        z-index: 999;
    }
</style>
